// extracted by mini-css-extract-plugin
export default {"card":"InfoCard_card__ZGX44","iconBox":"InfoCard_iconBox__z-5Ce","countBox":"InfoCard_countBox__GSjB+"};